import { gerar_melhor_sequencial_de_matricula } from "./gerar-melhor-sequencial-de-matricula";
import { consulta_retrato_matricula_por_escola } from "./consulta-retarato-matricula-por-escola";
import { consulta_melhor_sequencial_de_matricula } from "./consulta-melhor-sequencial-de-matricula-detalhes";
import { solicitar_retrato_de_matricula_inicial } from "./solicitar-retrato-de-matricula-inicial";

const retrato_de_matricula_inicial = [
  gerar_melhor_sequencial_de_matricula,
  consulta_retrato_matricula_por_escola,
  consulta_melhor_sequencial_de_matricula,
  solicitar_retrato_de_matricula_inicial,
];

export { retrato_de_matricula_inicial };
